export const initEvents = [];

export const initPlatform = {
  brand_name: '',
  regional_domain_prefix: '',
  selling_company_code: ''
};

export const initScreen = {
  type: 'home'
};

export const initUser = {
  type: 'customer',
  loginStatus: '',
  customerID: ''
};
